import { useState } from "react";

export type RequestStatusManagerErrorListType = {
    name?: string;
    message?: string;
}[];

export const useRequestStatusManager = () => {
    const [loadList, setLoadList] = useState<string[]>([]);

    const [errorList, setErrorList] =
        useState<RequestStatusManagerErrorListType>([]);

    const [success, setSuccess] = useState(false);

    const subscribeContent = (contentName: string) => {
        if (loadList.includes(contentName)) return;
        setLoadList((prevData) => [...prevData, contentName]);
    };

    const unsubscribeContent = (
        target: string,
        successfullyOperation = false
    ) => {
        setLoadList((loadList) =>
            loadList.filter((content) => content !== target)
        );

        setSuccess(successfullyOperation);
    };

    const setError = (contentName: string, errorMessage = "") => {
        setErrorList((prev) => [
            ...prev,
            { name: contentName, message: errorMessage },
        ]);
        unsubscribeContent(contentName);
    };

    const removeError = (contentName: string) => {
        setErrorList((prev) => prev.filter(({ name }) => name !== contentName));
    };

    const clearErrorList = () => setErrorList([]);

    const removeAllDataFromContent = (contentName: string) => {
        unsubscribeContent(contentName);
        setSuccess(false);
        clearErrorList();
    };

    const removeAllData = () => {
        setLoadList([]);
        setSuccess(false);
        clearErrorList();
    };

    const allContentIsReady = loadList.length === 0;
    const hasError = errorList.length > 0;

    return {
        subscribeContent,
        unsubscribeContent,
        setError,
        removeError,
        clearErrorList,
        setSuccess,
        removeAllDataFromContent,
        removeAllData,
        allContentIsReady,
        errorList,
        hasError,
        success,
    };
};
